import { useEffect } from "react";
import type { ConfiguratorSharedProps } from "../../widgetDefinition";
import { Typography } from "antd";
import { useSelector } from "react-redux";
import type { LogoComponentSpec } from "../../Processing/types";

const { Text } = Typography;


export function LogoConfigurator({ onSpecChange, existingSpec }: ConfiguratorSharedProps<LogoComponentSpec>) {
  const teamLogo: string | undefined = useSelector(
    ({ team }: any) => team.info?.team_logo,
  );

  // The logo widget has no user-tunable fields — emit a valid spec immediately
  // so the "Add Widget" button enables (otherwise currentSpec stays null).
  useEffect(() => {
    onSpecChange({ type: "logo", display: existingSpec?.display ?? {} });
  }, [onSpecChange, existingSpec]);

  return (
    <div className="awm-simple-configurator">
      <div className="awm-logo-preview-area">
        {teamLogo ? (
          <img
            src={teamLogo}
            alt="Team logo"
            style={{ maxWidth: 120, maxHeight: 120, objectFit: "contain" }}
            draggable={false}
          />
        ) : (
          <svg viewBox="0 0 100 100" width="96" height="96" aria-hidden>
            <defs>
              <linearGradient id="logo-preview-shine" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#1a3a5c" />
                <stop offset="100%" stopColor="#0d1f33" />
              </linearGradient>
              <linearGradient id="logo-preview-border" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#c9a227" />
                <stop offset="50%" stopColor="#f4e4a6" />
                <stop offset="100%" stopColor="#c9a227" />
              </linearGradient>
            </defs>
            <circle
              cx="50" cy="50" r="46"
              fill="url(#logo-preview-shine)"
              stroke="url(#logo-preview-border)"
              strokeWidth="4"
            />
            <text
              x="50" y="58"
              textAnchor="middle"
              fill="#f4e4a6"
              fontSize="28" fontWeight="700" fontFamily="serif"
              letterSpacing="2"
            >
              SC
            </text>
          </svg>
        )}
        <Text
          type="secondary"
          style={{ fontSize: 12, marginTop: 16, textAlign: "center", maxWidth: 280, lineHeight: 1.5 }}
        >
          Adds your team logo to the dashboard.
        </Text>
      </div>
    </div>
  );
}
